import { Component } from 'base/js/aem';
import { createApp } from 'vue';
import LocationsTemplate from './Locations.vue';

class Locations extends Component {
    init() {
        this.showLocations();
    }
    showLocations() {
        const locationPlaceHolder = this.element.querySelector('[data-locations-json]');
        if (locationPlaceHolder) {
            const locationsData = locationPlaceHolder.dataset.locationsJson;
            const locationsComponent = createApp(LocationsTemplate, { locationsData: JSON.parse(locationsData) });
            locationsComponent.mount(locationPlaceHolder);
        }
    }
}

export { Locations };
